import $ from 'jquery';
import Resumable from 'resumablejs';


import AssetRenderer from './asset-renderer';
import Error from "./error";

class Uploader {

	constructor() {

		$(".uploader").each((i, field) => {
			Uploader.setup(field);
		});

	}

	static setup(field, callback=null) {

		let wrapper = $(field).parent(".upload_container");

		$(wrapper).html(field); // reset the container.

		let name = $(field).attr("name");
		let key = $(field).data("key");
		let preview = $(field).data("preview");
		let autoopen = $(field).data("autoopen");
		let is_default = $(field).data("isdefault");
		let url = $(field).data("url");

		let row = $("<div></div>").addClass("row");
		$(wrapper).append(row);

		let col1 = $("<div></div>").addClass("col-xs-5");
		let col2 = $("<div></div>").addClass("col-xs-7");

		$(row).html(col1).append(col2);

		let asset = new AssetRenderer(preview);
	    asset.render(col1);


		let button = $("<button type=button class='btn btn-default'></button>").html("Edit").click(e => {

			let text = $("<div></div>").html("Click here or drag/drop a file to upload").addClass("textinfo");
			let container = $("<div></div>").addClass("filedrop").html(text);


			let token = $('meta[name="csrf-token"]').attr('content');
			var resumable = new Resumable({
			  target:'/upload',
			  maxFiles: 1,
			  query: {_token: token, key: key}
			});


			let progressbar = $("<div></div>").addClass("progress");


			resumable.on('fileSuccess', function(file, message){
			    console.log('fileSuccess',file);

				console.log("Callback", callback, message);
				
			    try {
				    let obj = JSON.parse(message);

				    let data = obj.storedFile;

				    $(field).removeClass("uploading");
				    $(field).addClass("uploaded");
				    $(field).val(data.id).change();
						
						if (callback) {
							callback(data, null);
						}

				    let asset = new AssetRenderer(AssetRenderer.cdn() + data.preview);
				    asset.render(col1);

				    $(container).slideUp('fast', () => {
						$(wrapper).find(".cancel-button").remove();
						$(container).remove();
					});

					$(row).slideDown('fast');

				} catch(ex) {
					// what now?
						if (callback) {
							callback(null, ex);
						}
				}

			  });
			resumable.on('fileProgress', function(file){


			    var progress = Math.round( resumable.progress() * 100 );
			    var right = 100 - progress;
			    console.log("progress", progress, right);
			    if (right > 80) {
			    	right = 80;
			    }
			    $(progressbar).css("right", right + "%").html(progress + "%").removeClass("preparing");

				if (progress == 100) {
					console.log("processing");
					$(progressbar).html("Processing...");
				}

			  });

			resumable.on('progress', function(){

				console.log("progress");

			  });

			resumable.on('fileAdded', function(file, event){

				$(text).hide();
				$(progressbar).html("").addClass("preparing");
				$(container).append(progressbar);

				$(container).addClass("progressing");

			    resumable.upload();
			    $(field).addClass("uploading");
			    $(field).removeClass("uploaded");
			    $(wrapper).find('.cancel-button').show();

			  });
			resumable.on('filesAdded', function(array){
			    //resumable.upload();
			    console.log('filesAdded', array);
			  });
			resumable.on('fileRetry', function(file){
			    console.log(file);
			  });
			resumable.on('fileError', function(file, message){
			    console.log('fileError', file, message);
			  });
			resumable.on('uploadStart', function(){
			    console.log('uploadStart');
			  });
			resumable.on('complete', function(){
			    console.log('complete');
			    $(progressbar).css("right", "0px").html("Processing...");
			  });
			resumable.on('error', function(message, file){
				try {
					let msg = JSON.parse(message);
					if (msg.error) {
						new Error("Error", msg.error, true);
					}
				} catch(e) {
					console.log("couldn't parse");
				}
			    console.log('error', message, file);
			  });
			resumable.on('pause', function(){
			    console.log('pause');
			  });
			resumable.on('cancel', function(){
			    console.log('cancel');
			  });

			$(wrapper).prepend(container);

			resumable.assignBrowse($(container).get(0));
			resumable.assignDrop($(container).get(0));

			$(container).hide();
			$(row).slideUp('fast');

			$(container).slideDown("fast", () => {
				// add a cancel button?

				let cancel = $("<button type=button>Cancel</button>").addClass("cancel-button btn btn-default").click(e => {
					e.preventDefault();
					resumable.cancel();
					$(container).slideUp('fast', () => {
						$(cancel).remove();
						$(container).remove();
					});

					$(field).removeClass("uploading");
					$(field).removeClass("uploaded");
					$(field).change();

					$(row).slideDown('fast');
				});
				$(wrapper).append(cancel);
				if (autoopen) {
					$(cancel).hide();
				}
			});
		});

		$(col2).append(button);

		if (!is_default) {
            let button2 = $("<button type=button class='btn btn-default'></button>").html("View").click(e => {
                e.preventDefault();
                window.open(url);
            });

            $(col2).append($("<div></div>").html(button2));
        }

		if (autoopen) {
			$(button).click();
		}

	}

}

export default Uploader;

